import { useState } from "react";
import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading } from "@/components/common";
import { BellRinging, CheckCircle, Warning, Info, FilmSlate, Scissors, Translate, ShareNetwork, CurrencyDollar } from "@phosphor-icons/react";

const ICON = { review: FilmSlate, shorts: Scissors, cost: CurrencyDollar, social: ShareNetwork, translation: Translate };

export default function Notifications() {
  const { data, loading } = useFetch("/notifications");
  const [items, setItems] = useState(null);
  const list = items || data;
  if (loading || !list) return <Loading />;

  const markAll = () => setItems(list.map((n) => ({ ...n, read: true })));
  const unread = list.filter((n) => !n.read).length;

  return (
    <div>
      <PageHeader icon={BellRinging} title="Notifications"
        subtitle="Everything that needs your attention — episodes ready, failures, approvals, publishing status, disconnected accounts and budget alerts."
        actions={<button data-testid="mark-all-read" onClick={markAll} className="rounded-full border border-white/10 bg-[#1C1C1C] px-4 py-2 text-sm text-white hover:border-white/30 transition-colors">Mark all read{unread ? ` (${unread})` : ""}</button>} />

      <div className="space-y-2">
        {list.map((n) => {
          const Icon = ICON[n.type] || Info;
          const col = n.level === "warning" ? "#FFB800" : n.level === "error" ? "#FF3366" : "#00E5FF";
          return (
            <Panel key={n.id} data-testid={`notif-${n.id}`} className={`flex items-start gap-4 ${!n.read ? "border-l-2" : ""}`} style={!n.read ? { borderLeftColor: col } : {}}>
              <div className="h-10 w-10 rounded-xl bg-white/5 flex items-center justify-center shrink-0"><Icon size={19} weight="duotone" style={{ color: col }} /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-medium text-white">{n.title}</span>
                  {!n.read && <span className="h-2 w-2 rounded-full" style={{ background: col }} />}
                </div>
                <p className="text-sm text-zinc-400">{n.body}</p>
              </div>
              <span className="text-xs text-zinc-600 shrink-0">{n.time}</span>
            </Panel>
          );
        })}
      </div>
    </div>
  );
}
